import ReactGA from 'react-ga'

export const GA_TRACKING_IDS: Record<string, string> = {
  'legolas.ponedev.net': 'UA-110166204-1',
  'uat.ponedev.net': 'UA-110166204-3',
  'partneringone.informaconnect.com': 'UA-116091670-1',
}

const trackingId = GA_TRACKING_IDS[window.location.hostname]

if (trackingId) {
  ReactGA.initialize(trackingId)
}

export function logPageView() {
  if (trackingId) {
    ReactGA.set({ page: window.location.pathname + window.location.search })
    ReactGA.pageview(window.location.pathname + window.location.search)
  }
}
